import React from 'react';
import styled from 'styled-components';
import { ListingDocumentType } from '@bb/domain/dist/types';
import { useBreakpoint } from 'hooks';
import { Select } from 'components';
import { DOCUMENT_TYPE_OPTIONS } from 'utils';

type PartialDocument = {
  documentType?: ListingDocumentType;
  uid: string;
};

type SelectTypeProps = {
  uid: string;
  documents: PartialDocument[];
  setDocuments: React.Dispatch<React.SetStateAction<PartialDocument[]>>;
};

const SelectType: React.FC<SelectTypeProps> = ({
  uid,
  documents,
  setDocuments,
}) => {
  const { md } = useBreakpoint();

  const document = React.useMemo(() => documents.find(doc => doc.uid === uid), [documents, uid]);

  const otherDocumentIsAgreement = React.useMemo(() => documents
      .filter(doc => doc !== document)
      .some(doc => doc.documentType === 'listingAgreement'), [documents]);

  const getOptions = () => {
    if (!otherDocumentIsAgreement) return DOCUMENT_TYPE_OPTIONS;
    return DOCUMENT_TYPE_OPTIONS.filter(
      ({ value }) => value !== 'listingAgreement',
    );
  };

  return (
    <StyledSelect
      onClick={e => e.stopPropagation()}
      value={document.documentType}
      options={getOptions()}
      placeholder="Select type"
      dropdownMatchSelectWidth={false}
      onChange={documentType =>
        setDocuments(prev =>
          prev.map(doc => {
            if (doc.uid === uid) return { ...doc, documentType };
            return doc;
          }),
        )
      }
      zIndex={2000}
      $md={md}
    />
  );
};

const StyledSelect = styled(Select)<{ $md: boolean }>`
  width: 250px;
  margin-right: 15px;
  text-align: left;
  ${({ $md }) =>
    !$md &&
    `
    grid-column-end: span 3;
    width: 100%;
    margin-top: 5px;
  `}
`;

export default SelectType;
